import React from "react";
import "./ToggleSorter.scss";
import Toggle from "./ToggleButton";

const ToggleSorter = ({ title , onClickHandler }) => {
  return (
    <div className="toggleSorterContainer_">
      <span>{title}</span>
      <Toggle label="Toggle me" toggled={false} onClick={onClickHandler}/>
    </div>
  );
};

export default ToggleSorter;
